import * as React from 'react';
import { colors } from '../../../index';

const IconVerified = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 12 11",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.342 4.06a.534.534 0 00-.702 0L5.51 5.987l-.89-.804a.534.534 0 00-.701 0 .42.42 0 000 .634l1.24 1.123a.522.522 0 00.351.131.522.522 0 00.35-.131l2.482-2.245a.42.42 0 000-.635z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.172 5.042a.459.459 0 00-.458.458 4.589 4.589 0 01-4.584 4.583A4.589 4.589 0 011.547 5.5 4.589 4.589 0 016.13.917c1.23 0 2.386.48 3.253 1.354a.458.458 0 10.65-.646A5.463 5.463 0 006.13 0a5.506 5.506 0 00-5.5 5.5c0 3.033 2.468 5.5 5.5 5.5 3.033 0 5.5-2.467 5.5-5.5a.459.459 0 00-.458-.458z"
  })));
};

export default IconVerified;